import { call, put, takeLatest, select } from "redux-saga/effects";
import { deleteSOWDetails } from "../http/requests/sow";
import { SOWType, getSOWData, setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";
import { toast } from "react-toastify";

function* workerDeleteSOWSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(deleteSOWDetails, payload.sowId);
    const clientId = yield select((state) => state.MODULES.sowListClientFilterId);
    toast.success("SOW Deleted", toastOptions);
    yield put(
      getSOWData({
        pageNo: 1,
        pageSize: 10,
        sortDir: "ASC",
        sortBy: "sowName",
        searchData: "",
        clientId,
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err?.response?.data?.errorMessage || err?.message || "Failed to delete SOW", toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* deleteSOWSaga() {
  yield takeLatest(SOWType.DELETE_SOW_DATA, workerDeleteSOWSaga);
}
